import NetworkLogic from "../Shared/NetworkLogic";
import Constant from "../Shared/Constant";
import UIManager from "../Shared/UIManager";
import { Global } from "../Shared/Global";
import Player from "../Models/Player";
import SDKManager from "../Shared/SDKManager";
import AudioManager from "../Shared/AudioManager";
import AddressManager from "../Shared/AddressManager";
import EnterSoundManager from "../Shared/EnterSoundManager";

const { ccclass, property } = cc._decorator;

@ccclass
export default class RegisterUI extends cc.Component {
    @property(cc.Prefab)
    pfbLoginUI: cc.Prefab = null

    @property(cc.Prefab)
    pfbLoginItem: cc.Node = null

    @property(cc.Node)
    nodeItems: cc.Node = null

    @property(cc.Node)
    nodeContent: cc.Node = null

    @property(cc.Node)
    nodeUserName: cc.Node = null

    @property(cc.Node)
    nodePhoneCode: cc.Node = null

    @property(cc.Node)
    nodeCode: cc.Node = null

    @property(cc.EditBox)
    ebUserName: cc.EditBox = null

    @property(cc.EditBox)
    ebPossword: cc.EditBox = null

    @property(cc.EditBox)
    ebConfirm: cc.EditBox = null

    @property(cc.EditBox)
    ebPhoneCode: cc.EditBox = null

    @property(cc.EditBox)
    ebCode: cc.EditBox = null

    @property(cc.Sprite)
    spCode: cc.Sprite = null

    @property(cc.Label)
    lbCodeTime: cc.Label = null

    private _codeId: number = 0
    private _codeCD: number = 0
    private _userLoginConfig: {} = null
    private _channelCode: string = ""
    private _bindData: {} = {};

    async start() {
        this.nodeItems.active = false;
        //await this.getInstallParms()
        this.downloadUserConfig()
        this.refreshCodeImage()
        this._channelCode = Global.installParms[0];
        this._bindData = Global.installParms[1];

        //let str = `_channelCode :${this._channelCode} ,_bindData :${this._bindData} `;
        //UIManager.showTipUI(str);
        EnterSoundManager.playSound("enter_zhuce")
    }

    update(dt) {
        if (this._codeCD > 0) {
            this._codeCD -= dt

            if (this._codeCD < 0) {
                this._codeCD = 0
                this.lbCodeTime.string = "发送验证码"
            } else {
                this.lbCodeTime.string = "重新发送(" + Math.ceil(this._codeCD).toString() + ")"
            }
        }
    }

    onBtnClick(event, userData) {
        if (userData === "register") {
            this.register()
        } else if (userData === "send") {
            if (this._codeCD > 0) {
                return
            }

            let phoneNum = cc.find("phone/EditBox", this.nodeContent) ? cc.find("phone/EditBox", this.nodeContent).getComponent(cc.EditBox).string : ""

            if (phoneNum.length !== 11 || !(/^\d+$/.test(phoneNum))) {
                UIManager.showToastUI("输入正确的手机号码！", Global.ToastType.Warnning)
            } else {
                NetworkLogic.phoneCode(phoneNum)
                this._codeCD = 60
            }
        } else if (userData === "go") {
            cc.instantiate(this.pfbLoginUI).parent = this.node.parent
            this.node.destroy()
        } else if (userData === "code") {
            this.refreshCodeImage()
        } else if (userData === "close") {
            AudioManager.playSound("close")
            this.node.destroy()
        }
    }

    private register() {
        if (!this.check()) {
            return
        }
        let agentCodeEdiBox = cc.find("agentCode/EditBox", this.nodeContent)
        let agentCodeEb = agentCodeEdiBox ? agentCodeEdiBox.getComponent(cc.EditBox).string : "";
        let bindCode = this._bindData ? this._bindData["code"] : "";
        let agentCode = bindCode || agentCodeEb;
        let domainId = "default";
        // 从原生里取，取到就用原生的
        let nativeChannel = "";
        if (cc.sys.os === cc.sys.OS_IOS) {
            nativeChannel = jsb.reflection.callStaticMethod("AppController", "nativeChannel");
        } else if (cc.sys.os === cc.sys.OS_ANDROID) {
            nativeChannel = jsb.reflection.callStaticMethod("org/cocos2dx/javascript/AppActivity", "nativeChannel", "()Ljava/lang/String;");
        }

        if(nativeChannel && nativeChannel !== 'default' && nativeChannel !== 'zheshiyuanshengqudaohao' && nativeChannel !== 'undefined'){
            domainId = nativeChannel;
        }else{
            domainId = this._channelCode;
        }

        let data = {
            "agentUrl": "",
            "channelDomain": "",
            "channelFlag": "",
            "code": this.ebCode.string,
            "codeId": this._codeId === 0 ? "" : this._codeId.toString(),
            "deviceFlag": "",
            "deviceModel": cc.sys.isMobile ? jsb.device.getDeviceModel() : "",
            "deviceType": cc.sys.os === cc.sys.OS_ANDROID ? "1" : "2",
            "domainId": domainId,
            "email": cc.find("email/EditBox", this.nodeContent) ? cc.find("email/EditBox", this.nodeContent).getComponent(cc.EditBox).string : "",
            "ipAdr": "",
            "parentAgentCode": agentCode,
            "phone": cc.find("phone/EditBox", this.nodeContent) ? cc.find("phone/EditBox", this.nodeContent).getComponent(cc.EditBox).string : "",
            "phoneCode": this.ebPhoneCode.string,
            "pwd": this.ebPossword.string,
            "qq": cc.find("qq/EditBox", this.nodeContent) ? cc.find("qq/EditBox", this.nodeContent).getComponent(cc.EditBox).string : "",
            "sign": "",
            "uaToken": "",
            "userId": this.ebUserName.string,
            "verifyPwd": this.ebConfirm.string,
            "weChat": cc.find("wechat/EditBox", this.nodeContent) ? cc.find("wechat/EditBox", this.nodeContent).getComponent(cc.EditBox).string : "",
            "webUmidToken": ""
        }

        // UIManager.showTipUI(data.domainId + "  " + data.parentAgentCode)

        NetworkLogic.register(data, function (data) {
            UIManager.showToastUI("注册成功！", Global.ToastType.OK)
            if (Constant.InstallSDK === 0) {
                SDKManager.reportRegister()
            }else if (Constant.InstallSDK === 1) {
                SDKManager.shareInstallReportRegister()
            }
            Player.setPy("token", data.token)
            this.node.destroy()
        }.bind(this), function (response) {
            if (!response) return
            this.refreshCodeImage()
        }.bind(this))
    }

    private refreshCodeImage() {
        this._codeId = Math.floor(Math.random() * 1000)
        let remoteUrl = AddressManager.getServerAdress() + "/api/user/generator-code?code_id=" + this._codeId.toString();
        cc.loader.load({ url: remoteUrl, type: 'png' }, function (err, texture: cc.Texture2D) {
            if (!err && this.node) {
                var spriteFrame = new cc.SpriteFrame(texture)
                this.spCode.spriteFrame = null
                this.spCode.spriteFrame = spriteFrame
            }
        }.bind(this));
    }

    private downloadUserConfig() {
        UIManager.showLoadingUI()
        NetworkLogic.userLoginConfig(function (data) {
            UIManager.hideLoadingUI()
            this._userLoginConfig = data
            this.showItemsFromLoginConfig()
        }.bind(this))
    }

    private showItemsFromLoginConfig() {
        this.nodeItems.active = true
        this.nodePhoneCode.active = false
        this.nodeCode.active = false

        // 注册图形验证码
        if (parseInt(this._userLoginConfig["isOpenReCode"]) === 0) {
            this.nodeCode.parent = null
            this.nodeCode.parent = this.nodeContent
            this.nodeCode.active = true
        }

        let registerTypeCfg = this._userLoginConfig["userLoginConfig"] || []

        for (let i = 0; i < registerTypeCfg.length; i++) {
            const cfg = registerTypeCfg[i];
            let loginItem = cc.instantiate(this.pfbLoginItem)
            let editBox = loginItem.getChildByName("EditBox").getComponent(cc.EditBox)

            loginItem.name = cfg["registerFieldName"]
            loginItem.getComponent(cc.Label).string = cfg["registerName"] + "："
            loginItem.parent = this.nodeContent
            editBox.placeholder = "请输入" + cfg["registerName"]

            if (cfg["registerName"] === "手机") {
                editBox.inputMode = cc.EditBox.InputMode.PHONE_NUMBER
                editBox.maxLength = 11
            } else if (cfg["registerName"] === "QQ") {
                editBox.inputMode = cc.EditBox.InputMode.NUMERIC
            }
            else if (cfg["registerFieldName"] === "agentCode") {
                loginItem.getComponent(cc.Label).string = "邀请码：" ;
                let str = "请输入邀请码";
                if  (!cfg["isNotNull"]){
                    loginItem.getComponent(cc.Label).string = "邀请码（选填）：" ;
                    str += "（选填）"
                }
                editBox.placeholder = str;
                editBox.maxLength = 15
                //this.agentCodeEb = editBox;
                if  (this._bindData && this._bindData["code"])  {
                    editBox.string = this._bindData["code"];
                    editBox.enabled = false;
                }
            }
        }



        // 注册手机验证码
        if (parseInt(this._userLoginConfig["isOpenPhoneCode"]) === 0) {
            this.nodePhoneCode.parent = null
            this.nodePhoneCode.parent = this.nodeContent
            this.nodePhoneCode.active = true
        }

        
    }

    private check(): boolean {
        if (this.ebUserName.string.length === 0) {
            UIManager.showToastUI("用户名不能为空，请填写！", Global.ToastType.Warnning)
            return false
        } else if (this.ebUserName.string.length < 6 || this.ebUserName.string.length > 12 || !(/\d+/.test(this.ebUserName.string) && /[a-zA-Z]+/.test(this.ebUserName.string))) {
            UIManager.showToastUI("用户名为6-12位数字与字母组合", Global.ToastType.Warnning)
            return false
        }

        if (this.ebPossword.string.length === 0) {
            UIManager.showToastUI("密码不能为空，请填写！", Global.ToastType.Warnning)
            return false
        } else if (this.ebPossword.string.length < 6 || this.ebPossword.string.length > 12 || !(/\d+/.test(this.ebPossword.string) && /[a-zA-Z]+/.test(this.ebPossword.string))) {
            UIManager.showToastUI("密码为6-12位数字与字母组合", Global.ToastType.Warnning)
            return false
        }

        if (this.ebConfirm.string.length === 0) {
            UIManager.showToastUI("确认密码不能为空，请填写！", Global.ToastType.Warnning)
            return false
        } else if (this.ebConfirm.string !== this.ebPossword.string) {
            UIManager.showToastUI("密码和确认密码不一致，请重新填写！", Global.ToastType.Warnning)
            return false
        }

        // 注册图形验证码
        if (parseInt(this._userLoginConfig["isOpenReCode"]) === 0) {
            if (this.ebCode.string.length === 0) {
                UIManager.showToastUI("验证码不能为空，请填写！", Global.ToastType.Warnning)
                return false
            }
        }

        let registerTypeCfg = this._userLoginConfig["userLoginConfig"] || []

        for (let i = 0; i < registerTypeCfg.length; i++) {
            const cfg = registerTypeCfg[i];
            let editBox = cc.find(cfg["registerFieldName"] + "/EditBox", this.nodeContent).getComponent(cc.EditBox)

            if (cfg["isNotNull"]) {
                if (editBox.string.length === 0) {
                    UIManager.showToastUI(cfg["registerName"] + "不能为空，请填写！", Global.ToastType.Warnning)
                    return false
                } else if (cfg["registerFieldName"] === "phone" && (editBox.string.length !== 11 || !(/^\d+$/.test(editBox.string)))) {
                    UIManager.showToastUI("输入正确的手机号码！", Global.ToastType.Warnning)
                    return false
                }
            }
        }

        // 手机验证码
        if (parseInt(this._userLoginConfig["isOpenPhoneCode"]) === 0) {
            if (this.ebPhoneCode.string.length === 0) {
                UIManager.showToastUI("手机验证码不能为空，请填写！", Global.ToastType.Warnning)
                return false
            }
        }


        return true
    }


    private getInstallParms() {
        if (!cc.sys.isMobile) return
        if (cc.sys.os === cc.sys.OS_IOS) {
            let nativeChannel = jsb.reflection.callStaticMethod("AppController", "nativeChannel");
            if (nativeChannel && nativeChannel !== 'default' && nativeChannel !== 'zheshiyuanshengqudaohao' && nativeChannel !== 'undefined') {
                this._channelCode = nativeChannel;
            }
        } else if (cc.sys.os === cc.sys.OS_ANDROID) {
            let nativeChannel = jsb.reflection.callStaticMethod("org/cocos2dx/javascript/AppActivity", "nativeChannel", "()Ljava/lang/String;");
            if (nativeChannel && nativeChannel !== 'default' && nativeChannel !== 'zheshiyuanshengqudaohao' && nativeChannel !== 'undefined') {
                this._channelCode = nativeChannel;
            }
        }
        if (Constant.InstallSDK === 0) {
            SDKManager.getInstallParms(function (data) {
                cc.log("install parms:" + (data ? JSON.stringify(data) : ""))
                // 从openinstall 获取了一次了
                this._channelCode = (data && data["channelCode"]) ? data["channelCode"] : "";
                if (cc.sys.os === cc.sys.OS_IOS) {
                    let nativeChannel = jsb.reflection.callStaticMethod("AppController", "nativeChannel");
                    if (nativeChannel && nativeChannel !== 'default' && nativeChannel !== 'zheshiyuanshengqudaohao' && nativeChannel !== 'undefined') {
                        this._channelCode = nativeChannel;
                    }
                } else if (cc.sys.os === cc.sys.OS_ANDROID) {
                    let nativeChannel = jsb.reflection.callStaticMethod("org/cocos2dx/javascript/AppActivity", "nativeChannel", "()Ljava/lang/String;");
                    if (nativeChannel && nativeChannel !== 'default' && nativeChannel !== 'zheshiyuanshengqudaohao' && nativeChannel !== 'undefined') {
                        this._channelCode = nativeChannel;
                    }
                }
                this._bindData = (data && data["bindData"]) ? JSON.parse(data["bindData"]) : {}
            }.bind(this))
        }else if (Constant.InstallSDK === 1) {
            SDKManager.getShareInstallParm(function (data) {
                cc.log("install parms:" + (data ? JSON.stringify(data) : ""))
                this._channelCode = (data && data["channelCode"]) ? data["channelCode"] : "";
                if (cc.sys.os === cc.sys.OS_IOS) {
                    let nativeChannel = jsb.reflection.callStaticMethod("AppController", "nativeChannel");
                    if (nativeChannel && nativeChannel !== 'default' && nativeChannel !== 'zheshiyuanshengqudaohao' && nativeChannel !== 'undefined') {
                        this._channelCode = nativeChannel;
                    }
                } else if (cc.sys.os === cc.sys.OS_ANDROID) {
                    let nativeChannel = jsb.reflection.callStaticMethod("org/cocos2dx/javascript/AppActivity", "nativeChannel", "()Ljava/lang/String;");
                    if (nativeChannel && nativeChannel !== 'default' && nativeChannel !== 'zheshiyuanshengqudaohao' && nativeChannel !== 'undefined') {
                        this._channelCode = nativeChannel;
                    }
                }
                this._bindData = {"code": (data && data["code"]) ? data["code"] : ""}
            }.bind(this))
        }else if (Constant.InstallSDK === 2) {
            SDKManager.getShareTraceParm(function (data) {
                this._channelCode = (data && data["channelCode"]) ? data["channelCode"] : "";
                if (cc.sys.os === cc.sys.OS_IOS) {
                    let nativeChannel = jsb.reflection.callStaticMethod("AppController", "nativeChannel");
                    if (nativeChannel && nativeChannel !== 'default' && nativeChannel !== 'zheshiyuanshengqudaohao' && nativeChannel !== 'undefined') {
                        this._channelCode = nativeChannel;
                    }
                } else if (cc.sys.os === cc.sys.OS_ANDROID) {
                    let nativeChannel = jsb.reflection.callStaticMethod("org/cocos2dx/javascript/AppActivity", "nativeChannel", "()Ljava/lang/String;");
                    if (nativeChannel && nativeChannel !== 'default' && nativeChannel !== 'zheshiyuanshengqudaohao' && nativeChannel !== 'undefined') {
                        this._channelCode = nativeChannel;
                    }
                }
                this._bindData = {"code": (data && data["code"]) ? data["code"] : ""}
                // UIManager.showTipUI(JSON.stringify(data))
            }.bind(this))
        }
    }
}